import React from 'react'

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { styled } from '@mui/material/styles'

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      padding: '20px',
      maxWidth: '350px',
      maxHeight: '500px',
      overflowY: 'auto',
      color: theme.palette.text.white,
      backgroundColor: theme.palette.color.blueLight2,
      boxShadow: theme.shadows[1],
    },
  }),
)

const InfoTooltip = ({ content }) => {
  return (
    <>
      {content && (
        <LightTooltip title={content} placement="right-start">
          <InfoOutlinedIcon sx={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', color: '#0099FF' }} />
        </LightTooltip>
      )}
    </>
  )
}

export default InfoTooltip
